export const viewTitle = "Реестр описей дел, документов";
export const viewUniqKey = "inventoriesRegisterReport";
